import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter, useLocation } from "react-router-dom";

import './index.css';
import 'bootstrap/dist/css/bootstrap.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';

import App from './App';
import reportWebVitals from './reportWebVitals';

const themeMui = createTheme({
  palette: {
    primary: {
      main: '#05386B'
    },
    secondary: {
      main: '#5CDB95',
    },
  }
});

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    document.getElementsByTagName('html')[0].style.removeProperty('scroll-behavior');
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HashRouter>
      <ScrollToTop />
      <ThemeProvider theme={themeMui}>
        <App />
      </ThemeProvider>
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
